import React, { useState, useEffect, useRef } from "react";
import useKeyPress from "./hooks/useKeyPress";
import { currentTime } from "./utils/time";
import { generate } from "./utils/words";

const initialWords = generate();

//App
function App() {
  //new code
  //design the state of typing lines, set left side to 20 spaces to keep current character at center of screen.
  const [leftPadding, setLeftPadding] = useState(
    new Array(20).fill(" ").join("")
  );
  const [outgoingChars, setOutgoingChars] = useState("");
  const [currentChar, setCurrentChar] = useState(initialWords.charAt(0));
  const [incomingChars, setIncomingChars] = useState(initialWords.substr(1));
  //WPM states
  const [startTime, setStartTime] = useState();
  const [wordCount, setWordCount] = useState(0);
  const [wpm, setWpm] = useState(0);

  const [accuracy, setAccuracy] = React.useState(0);
  const [typedChars, setTypedChars] = useState(``);
  //end of new code

  //set our starting time variable in all caps because that's the standard and make it a global variable
  const STARTING_TIME = 30;

  //States
  //start our text inside our textarea as an empty string
  const [text, setText] = React.useState("");

  //set a timer for 5 seconds
  const [timeRemaining, setTimeRemaining] = React.useState(STARTING_TIME);

  //start our gameRunning at false so timer doesnt start counting down automatically
  const [isTimeRunning, setIsTimeRunning] = React.useState(false);

  //make it focus on textarea when game starts
  const textBoxRef = useRef(null);

  // //high score
  // const [highScore, setHighScore] = React.useState(false);

  //let players set starting time changes
  const [startingTime, setStartingTime] = React.useState(STARTING_TIME);

  //Functions

  useKeyPress((key) => {
    //when u type something when time is 0 aka not running it will make key false so typing doesnt work and accuracy is false so it doesnt change when timer is not running
    if (!isTimeRunning) {
      console.log("make typing unavailable");
      key = false;
      accuracy(false);
    }
    // this function works if time is running
    else if (!startTime && isTimeRunning) {
      setStartTime(currentTime());
    }

    let updatedOutgoingChars = outgoingChars;
    let updatedIncomingChars = incomingChars;
    if (key === currentChar) {
      if (leftPadding.length > 0) {
        setLeftPadding(leftPadding.substring(1));
      }
      updatedOutgoingChars += currentChar;
      setOutgoingChars(updatedOutgoingChars);

      setCurrentChar(incomingChars.charAt(0));

      updatedIncomingChars = incomingChars.substring(1);
      if (updatedIncomingChars.split(" ").length < 10) {
        updatedIncomingChars += " " + generate();
      }
      setIncomingChars(updatedIncomingChars);

      if (incomingChars.charAt(0) === " ") {
        setWordCount(wordCount + 1);
        const durationInMinutes = (currentTime() - startTime) / 60000.0;
        setWpm(((wordCount + 1) / durationInMinutes).toFixed(2));
      }
    }

    const updatedTypedChars = typedChars + key;
    setTypedChars(updatedTypedChars);
    setAccuracy(
      ((updatedOutgoingChars.length * 100) / updatedTypedChars.length).toFixed(
        2
      )
    );
  });

  //handle timer so players can set their own time
  function handleTimerChange(event) {
    const { value } = event.target;
    setStartingTime(value);
    setTimeRemaining(value);
  }

  // every time we type in the text area show the text
  function handleChange(event) {
    const { value } = event.target;
    setText(value);
  }

  //a function that counts words,  ignores empty spaces/strings, and returns the amount of words typed through filtering by length
  function calculateWordCount(text) {
    const wordsArr = text.trim().split(" ");
    const filteredWords = wordsArr.filter((word) => word !== "");
    return filteredWords.length;
  }

  //when they hit start game make everything clear
  function startClock() {
    setIsTimeRunning(true);
    setTimeRemaining(startingTime);
    setText("");
    textBoxRef.current.disabled = false;
    textBoxRef.current.focus();
    setAccuracy(0);
    setWpm(0);
    setWordCount(0);
    //figure out eventually how to regenerate new words when game is started
  }

  //end the game when timer hits 0
  function endGame() {
    //stop the timer
    setIsTimeRunning(false);
    //count words at 0 seconds
    setWordCount(calculateWordCount(text));
    // setHighScore(true);
    //disable ability to type
  }

  //useEffect

  //Our time running state starts as false and our time remaining starts at 5. We use useEffect to make it countdown to 0 based on state. If our time is greater than 0 which it is at the start because our state starts at 5 this function will keep running and subtracting by 1 second from the time also if our timeRunning is true we run this same function where we set a timer that decreases by a second. Once our time remaining hits 0 we set our timeRunning to false to make it stop. We base our use Effect on the State of timeRemaining and isTimeRunning.
  React.useEffect(() => {
    if (isTimeRunning && timeRemaining > 0) {
      setTimeout(() => {
        setTimeRemaining((time) => time - 1);
      }, 1000);
    } else if (timeRemaining === 0) {
      endGame();
    }
  }, [timeRemaining, isTimeRunning]);

  const preventMinus = (e) => {
    if (e.code === "Minus") {
      e.preventDefault();
    }
  };

  //Return

  return (
    <div>
      <h1>Typing Speed Test: How fast can you type?</h1>
      <div className="Character">
        <span className="Character-out">
          {(leftPadding + outgoingChars).slice(-20)}
        </span>
        <span className="Character-current">{currentChar}</span>
        <span>{incomingChars.substr(0, 20)}</span>
        <h3 className="Score-characters">
          {" "}
          WPM: {wpm} | ACC: {accuracy}%
        </h3>
      </div>
      <textarea
        className="Character"
        ref={textBoxRef}
        placeholder="type here after hitting the start button"
        onChange={handleChange}
        value={text}
        //don't let users start typing until they hit start game
        disabled={!isTimeRunning}
      ></textarea>

      <h4>
        Change the timer:
        <input
          //let users only type positive numbers for timer
          type="number"
          name="test_name"
          min="1"
          onChange={handleTimerChange}
          onKeyPress={preventMinus}
          //prevent copy and paste
          onPaste={(e) => {
            e.preventDefault();
            return false;
          }}
          onCopy={(e) => {
            e.preventDefault();
            return false;
          }}
          //end of test
          value={startingTime}
          disabled={isTimeRunning}
        />{" "}
        sec(s)
      </h4>
      <h4>Time Remaining:{timeRemaining} sec(s)</h4>

      {/* need to still figure out and explain why we have to do () => inside out onClick instead of just
      setIsTimeRunning(true) so far I've just figured out that this is something
      we always have to do in React with event listeners and onEvents 
      Are we using the anonymous function to obtain state? Why do we need this anonymous function?

      oh its like in vanilla, redButton.addEventListener(`click`, function(event)) so 
      */}

      <button
        onClick={startClock}
        //disable Start button on click
        disabled={isTimeRunning}
      >
        {" "}
        Start Game
      </button>
      <h1> Word Count {wordCount}</h1>
    </div>
  );
}

export default App;
